/*
 * Wspólne formatowanie dat używane przez karty, sticky pasek i katalog.
 * Daty z API są odczytywane bez konwersji strefy czasowej, aby dzień wyjazdu
 * nie zmieniał się zależnie od ustawień urządzenia użytkownika.
 */

const MONTH_NAMES = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
]

const MONTH_SHORT_NAMES = [
  'sty',
  'lut',
  'mar',
  'kwi',
  'maj',
  'cze',
  'lip',
  'sie',
  'wrz',
  'paź',
  'lis',
  'gru',
]

export function parseApiDate(value) {
  const match = String(value).match(
    /^\s*(\d{4})-(\d{1,2})-(\d{1,2})/
  )

  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])

  if (
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return null
  }

  return { year, month, day }
}

/**
 * Określa porę roku według konkretnego dnia:
 * wiosna 21.03, lato 22.06, jesień 23.09, zima 22.12.
 */
export function getSeasonFromStartDate(startDate) {
  const date = parseApiDate(startDate)

  if (!date) return 'winter'

  const monthAndDay = date.month * 100 + date.day

  if (monthAndDay >= 321 && monthAndDay < 622) {
    return 'spring'
  }

  if (monthAndDay >= 622 && monthAndDay < 923) {
    return 'summer'
  }

  if (monthAndDay >= 923 && monthAndDay < 1222) {
    return 'autumn'
  }

  return 'winter'
}

/**
 * Tworzy zwarty zapis odpowiedni do szerokości nagłówka karty:
 * 28-30 listopada 2027
 * 28 wrz - 3 paź 2027
 * 28 gru 2027 - 3 sty 2028
 */
export function formatTermDate(
  startDate,
  endDate,
  fallbackDate = ''
) {
  const start = parseApiDate(startDate)
  const end = parseApiDate(endDate)

  if (!start || !end) return fallbackDate

  const sameYear = start.year === end.year
  const sameMonth =
    sameYear && start.month === end.month
  const sameDay =
    sameMonth && start.day === end.day

  if (sameDay) {
    return `${start.day} ${MONTH_NAMES[start.month - 1]} ${start.year}`
  }

  if (sameMonth) {
    return `${start.day}-${end.day} ${MONTH_NAMES[start.month - 1]} ${start.year}`
  }

  if (sameYear) {
    return `${start.day} ${MONTH_SHORT_NAMES[start.month - 1]} - ${end.day} ${MONTH_SHORT_NAMES[end.month - 1]} ${start.year}`
  }

  return `${start.day} ${MONTH_SHORT_NAMES[start.month - 1]} ${start.year} - ${end.day} ${MONTH_SHORT_NAMES[end.month - 1]} ${end.year}`
}
